"use client";

import Link from "next/link";
import {
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

type Props = {
  href: string;
  isActive: boolean;
  className?: string;
  children: React.ReactNode;
};

/**
 * ソート可能サイドバー用のDragOverlayコンポーネント
 * snapCenterToCursorが適切に動作するようシンプルな構造に
 */
export default function SortableOverlay({
  href,
  isActive,
  className,
  children,
}: Props) {
  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        isActive={isActive}
        className={cn(
          className,
          isActive && "bg-primary/10! text-primary! [&_svg]:text-primary",
        )}
      >
        <Link
          href={href}
          style={{
            pointerEvents: "none",
          }}
        >
          {children}
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
